import { TipoIstanzaFascicoloVO } from "../vo/tipo-istanza-fascicoloVO";
import { ClassificaVO } from "../vo/classificaVO";
import { StatoFascicoloEnum } from "../enum/stato-fascicolo-enum";
import { StrutturaVO } from "../vo/strutturaVO";
import { UtenteVO } from "../vo/utenteVO";
import { IstanzeProcedimentoVO } from "../vo/istanze-procedimentoVO";
import { CampoSpecificoFascicoloVO } from "../vo/campo-specifico-fascicoloVO";
import { RiferimentoEsternoVO } from "./riferimento-esternoVO";
import { ProcedimentoVO } from "./procedimentoVO";
import { StrutturaFascicoloVO } from "./struttura-fascicoloVO";
import { TipologiaFascicoloVO } from "./tipologia-fascicoloVO";
import { TipologiaIperFascicoloVO } from "./tipologia-iper-fascicoloVO";
import { CommentoVO } from "./commentoVO";
import { VisibilitaFascicoloVO } from "./visibilita-fascicoloVO";
import { AttivitaEreditataVO } from "./procedimento-ereditatoVO";
import { WrapperCollegamentoFascicoloVO } from "./wrapper-collegamento-fascicoloVO";
import { MetadatiRepertorioVO } from "./metadati-repertorioVO";
import { DatiReportorioManualiVO } from "./dati-repertorio-manualiVO";
import { IstanzaAttivitaVO } from "./istanza-attivitaVO";

export class IperFascicoloVO {
  id: string;

  tipologia: TipoIstanzaFascicoloVO;
  tipologiaIperFascicolo: TipologiaIperFascicoloVO = new TipologiaIperFascicoloVO();
  oggetto: string;

  descrizione: string;

  classifica: ClassificaVO;

  segnaturaArchivistica: string;

  stato: StatoFascicoloEnum;

  dataApertura: string;

  dataChiusura: string;

  dataAnnullamento: string;

  idFascicoliContenuti: string[];

  wrapperFascicoliContenuti: WrapperCollegamentoFascicoloVO[];

  creatoDa: UtenteVO;

  strutturaResponsabile: StrutturaFascicoloVO;

  riferimentoFascicoloEsterno: RiferimentoEsternoVO;

  attivitaAssociata: IstanzaAttivitaVO;

  attivitaEreditate: AttivitaEreditataVO[];

  campiSpecifici: CampoSpecificoFascicoloVO[];

  referenteFascicolo: UtenteVO;

  istanzeProcedimento: IstanzeProcedimentoVO[];

  commenti: CommentoVO[];

  visibilitaIperFascicolo: VisibilitaFascicoloVO[];

  metadatiRepertorio: MetadatiRepertorioVO;

  datiRepertorioManuali: DatiReportorioManualiVO;
}
